var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShieldCheck68Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_694)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0002 15.3L18.7002 22.1V32.3C18.7002 41.7351 25.2282 50.558 34.0002 52.7001C42.7722 50.558 49.3002 41.7351 49.3002 32.3V22.1L34.0002 15.3ZM45.9002 32.3C45.9002 39.984 40.8342 47.073 34.0002 49.181C27.1662 47.073 22.1002 39.984 22.1002 32.3V24.31L34.0002 19.023L45.9002 24.31V32.3ZM26.1972 33.303L23.8002 35.7001L30.6002 42.5L44.2002 28.9L41.8032 26.486L30.6002 37.689L26.1972 33.303Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShieldCheck68Px);
export default __webpack_public_path__ + "static/media/ic_shield_check_68px.958c4e2bdf713dfc054430a767dcf960.svg";
export { ForwardRef as ReactComponent };